import ReactDOM from 'react-dom';
import SolutionAdvisor from './components/SolutionAdvisor';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './SolutionAdvisor.widget';
import { RenderFn } from 'src/types/widgets';
import 'carbon-components/css/carbon-components.min.css';
import { Provider } from 'react-redux';
import { TranslationProvider } from 'src/common/components/TranslationProvider/TranslationProvider';
import store from './lib/redux/store';

export interface widgetProps {
  isActiveStep: boolean;
}

const render: RenderFn = async function (instanceId, langCode, _origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );
  if (!element || !locale || !messages) {
    return;
  }
  const localeCode = element.getAttribute('data-localecode') || 'en-uss';
  const isActive: string | boolean =
    Boolean(element.getAttribute('data-isActive')) || false;

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider locale={locale} messages={messages} defaultLocale="en">
        <TranslationProvider messages={messages}>
          <SolutionAdvisor
            langCode={localeCode}
            test={false}
            countryToTest={'us'}
            isActiveStep={isActive}
          />
        </TranslationProvider>
      </IntlProvider>
    </Provider>,
    element,
    () => cb(element),
  );
};

export default render;
